<template>
  <div>
    <div class="main-title selfService">
      自助服务
    </div>
    <div class="main-cates">
      <div
        class="item-block"
        v-for="(item, index) in selfServiceList"
        :key="index"
        :zz-sortid="index"
        :zz-sortname="item.desc"
        @click="handleJump(item)"
      >
        <img class="imgCon" :src="$setPicSize(item.icon)" />
        <div class="text">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { setPicSize } from '@zz-common/zz-utils'
import { lego } from '@zz-common/lego'
import { getCookie } from '../../../lib/utils'
import { getKfSelfServiceEntrance } from '@api/resourceApi'
// 原入口配置--先不删除，以后做比对
// const selfServiceList = [
//   {
//     name: '扫描二维码',
//     type: 'qrCodeReader',
//     jumpUrl: 'zhuanzhuan://jump/core/qrCodeReader/jump?from=2', // 没有用到
//     imgUrl: require('./../../../assets/img/scanning.png')
//   },
//   {
//     name: '修改昵称',
//     type: 'changePersonInfo',
//     jumpUrl: 'zhuanzhuan://jump/core/personInfo/jump',
//     imgUrl: require('./../../../assets/img/reName.png')
//   },
//   // {
//   //   name: '修改手机号',
//   //   type: 'changPhone',
//   //   jumpUrl: 'zhuanzhuan://jump/core/changePhone/jump',
//   //   imgUrl: require('./../../../assets/img/renamePhone.png')
//   // },
//   {
//     name: '实名认证',
//     type: 'realPersonAuth',
//     jumpUrl: 'zhuanzhuan://jump/core/personHome/jump',
//     imgUrl: require('./../../../assets/img/certification.png')
//   },
//   {
//     name: '投诉反馈',
//     type: 'complaintCenter',
//     jumpUrl: '',
//     imgUrl: require('./../../../assets/img/complaint_center.png')
//   }
// ]
export default {
  name: 'SelfService',
  data() {
    return {
      selfServiceList: []
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url)
    },
    handleJump: function(item) {
      console.log('handleJump', item)
      lego.send({
        pagetype: 'ZZUP_HELPCENTER',
        actiontype: 'TOOL_CLICK',
        backup: {
          name: item.entranceType
        }
      })
      let jumpUrl = item.link
      // 实名认证--添加uid参数
      if (item.entranceType === 'realPersonAuth') {
        jumpUrl = `${jumpUrl}?uid=${getCookie('uid')}`
      }
      // 扫描二维码--吊起二维码功能--不做跳转处理
      if (item.entranceType === 'qrCodeReader') {
        native.wrap('enterPassportBox')()
        jumpUrl = '-1'
      }
      if (jumpUrl !== '-1') {
        native.skipToUrl({
          targetUrl: jumpUrl
        })
      }
    }
  },
  mounted() {
    // 获取自助服务配置
    getKfSelfServiceEntrance({
      num: 0 // 需要的自助服务功能的个数--建议不要超过5个，因为新样式需要UI重新设计
    })
      .then((res) => {
        if (res) {
          this.selfServiceList = res
        }
      })
  }
}
</script>

<style lang="less" scoped>
  @import 'SelfService.less';
  @import '../HelpCenter.less';
</style>
